module.exports = __webpack_public_path__ + "static/media/mar.97f422a5.jpg";